var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"350c4ed9b949290f9f97149d6da9805b4fe54ff8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["the-headless-club@commerce-ui-dev"]={id:"350c4ed9b949290f9f97149d6da9805b4fe54ff8"};
      